import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = theme => {
    return {
        root: {
            marginBottom: "20px",
            "&:empty": {
                marginBottom: 0,
            },
            "&:last-child": {
                marginBottom: 0,
            },
        },
        noMargin: {
            marginBottom: "0 !important",
        },
        isHide: {
            display: "none",
        },
        [`@media (max-width: ${theme.media.sm})`]: {
            root: {
                marginBottom: "10px",
            },
        },
    };
};

class FixedPanelItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let classes = this.props.classes;
        return (
            <div
                className={classNames(classes.root, {
                    [classes.noMargin]: this.props.noMargin,
                    [classes.isHide]: this.props.isHide,
                })}
            >
                {this.props.children}
            </div>
        );
    }
}

export default withStyles(styles)(FixedPanelItem);
